// @ts-nocheck
/**
 * Role picker used above user list pages. Renders a labelled dropdown when
 * the current user can act as multiple roles, or a plain label when only
 * one role is available.
 */
import { ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

const RenderUserAccessRolesList = ({
  activeUserAccessRole,
  userAccessRoles,
  setActiveUserAccessRole,
}) => {
  if (!activeUserAccessRole || !userAccessRoles) return null;

  if (userAccessRoles.length === 1) {
    return <span className="text-sm font-medium">{userAccessRoles[0].label}</span>;
  }

  if (userAccessRoles.length > 1) {
    const activeLabel =
      userAccessRoles.find((r) => String(r.value) === String(activeUserAccessRole))?.label ||
      'Select role';
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm" className="gap-1">
            {activeLabel}
            <ChevronDown className="h-3.5 w-3.5" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start">
          {userAccessRoles.map((role, idx) => (
            <DropdownMenuItem
              key={idx}
              onClick={() => setAccessRole(setActiveUserAccessRole, role.value)}
              className={
                String(role.value) === String(activeUserAccessRole)
                  ? 'bg-accent font-medium text-accent-foreground'
                  : undefined
              }
            >
              {role.label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  return null;
};

// Extracted so the Item onClick stays a stable one-liner even when the caller
// passes a plain setter or an action-dispatch style function.
function setAccessRole(setter, value) {
  if (typeof setter === 'function') setter(value);
}

export default RenderUserAccessRolesList;
